import React, { Component } from "react";
import { css } from "emotion";
import moment from "moment";
import _ from "lodash";
import { DateInput } from "semantic-ui-calendar-react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import {
  Button,
  Grid,
  Modal,
  Table,
  Checkbox,
  Dropdown,
  Input
} from "semantic-ui-react";
import { format } from "../../utilities/date";
import { getPOIdentifiers } from "../../services/offpriceServices";

const defaultValues = {
  16: "Bulk"
};

const disableByInputs = {
  7: ["14"],
  14: ["7"]
};

const extraOptions = {
  12: {
    maxLength: 20
  },
  15: {
    disabled: true
  }
};

const getDefaultValueByDataType = dataType => {
  switch (dataType) {
    case "BOOL":
      return false;
    default:
      return "";
  }
};

const customInput = {
  7: function(options) {
    let value = options.value;

    return (
      <div className="ui input">
        <DatePicker
          showMonthYearPicker
          dateFormat="MM/yy"
          selected={value}
          className="dateinput"
          onKeyDown={(e) => {
            if (!_.includes([8, 17, 37, 39], e.keyCode) && !e.ctrlKey) {
              e.preventDefault();
            }
          }}
          {...options}
        />
      </div>
    );
  }
};

const onChangeAdditional = {
  7: function(id, callback = () => {}) {
    const { IndcDate } = this.props;
    const { poidentifiers, orderIdentifiers } = this.state;

    let value = orderIdentifiers[id];

    if (moment().isAfter(value)) {
      value = new Date();
    }

    const momentValue = moment(value);
    const isSameMonthAndYear =
      momentValue.isSame(IndcDate, "month") &&
      momentValue.isSame(IndcDate, "year");

    return this.setState(
      {
        orderIdentifiers: {
          ...orderIdentifiers,
          15: isSameMonthAndYear,
          14: false,
          [id]: value
        }
      },
      callback
    );
  },
  10: function(id, callback) {
    const { orderIdentifiers } = this.state;

    return this.setState(
      {
        orderIdentifiers: {
          ...orderIdentifiers,
          [id]: orderIdentifiers[id].slice(0, 11)
        }
      },
      callback
    );
  }
};

const style = css`
  & table.table div.ui {
    &.input,
    &.search {
      width: 100%;
    }
  }

  & .react-datepicker-wrapper {
    width: 100%;

    .react-datepicker__input-container {
      width: 100%;

      .dateinput {
        width: 100%;
        padding: 10px;
        border-style: solid;
        border-width: 1px;
        border-color: #ddd;
        border-radius: 5px;
      }
    }
  }

  & .react-datepicker-popper {
    z-index: 10;
  }
`;

export default class POIdentifierModal extends Component {
  state = {
    poidentifiers: [],
    modalOpen: false,
    orderIdentifiers: {}
  };

  componentDidMount() {
    getPOIdentifiers().then(res => {
      const poidentifiers = res.data.map(poidentifier => ({
        ...poidentifier,
        POIdNbr: poidentifier.POIdNbr.trim(),
        IdentifierDesc: poidentifier.IdentifierDesc.trim(),
        DataType: poidentifier.DataType.trim()
      }));

      const orderIdentifiers = poidentifiers.reduce((acc, poidentifier) => {
        const { POIdNbr, DataType } = poidentifier;
        const defaultValue = defaultValues[POIdNbr];

        return {
          ...acc,
          [POIdNbr]: defaultValue || getDefaultValueByDataType(DataType)
        };
      }, {});

      this.setState({ poidentifiers, orderIdentifiers });
    });
  }

  componentDidUpdate(prevProps) {
    const prevPOIdentifiers = prevProps.POIdentifiers.sort();
    const POIdentifiers = this.props.POIdentifiers.sort();
    const { orderIdentifiers } = this.state;

    if (!_.isEqual(POIdentifiers, prevPOIdentifiers)) {
      const newOrderIdentifiers = POIdentifiers.reduce((acc, poidentifier) => {
        const { POIdNbr, POIdValue } = poidentifier;
        const stateValue = orderIdentifiers[POIdNbr];
        const parsedStateValue = this.parseStringValue(stateValue);
        const parsedPropValue = this.parseStringValue(POIdValue);
        const value =  parsedPropValue || parsedStateValue;

        return { ...acc, [POIdNbr]: value };
      }, orderIdentifiers);

      this.setState({ orderIdentifiers: newOrderIdentifiers }, () => {
        this.props.onPOIdentifierChange(this.state.orderIdentifiers);
      });
    }
  }

  parseStringValue(value) {
    const isYesValue = value === "Y";
    const momentValue = moment(value, "MM/YY");

    if (isYesValue || value === "N") {
      return isYesValue ? true : false;
    }

    if (momentValue.isValid() && momentValue.isBetween(moment().subtract(1, "y"), moment().add(1, "y"))) {
      return momentValue.toDate();
    }

    return value;
  }

  getComponentByPOIdentifier = POIdentifier => {
    const { orderIdentifiers } = this.state;
    const { POIdNbr, DataType, ValueList = [] } = POIdentifier;

    const getCustomComponent = customInput[POIdNbr];
    const value = orderIdentifiers[POIdNbr];
    const inputIds = disableByInputs[POIdNbr];
    const options = extraOptions[POIdNbr];

    let isDisabled;

    if (inputIds) {
      isDisabled = inputIds.some(id => !!orderIdentifiers[id]);
    }

    if (getCustomComponent) {
      return getCustomComponent.call(this, {
        value,
        onChange: date => this.handleInputChange({ [POIdNbr]: () => date })()
      });
    }

    switch (DataType) {
      case "BOOL":
        return (
          <Checkbox
            toggle
            disabled={isDisabled}
            checked={value}
            label={value ? "Yes" : "No"}
            onChange={this.handleInputChange({
              [POIdNbr]: ({ checked }) => checked
            })}
            {...options}
          />
        );
      case "LIST":
        return (
          <Dropdown
            search
            selection
            value={value}
            disabled={isDisabled}
            options={ValueList.map(({ SubElementId, Desc }) => ({
              key: SubElementId,
              text: Desc,
              value: Desc
            }))}
            onChange={this.handleInputChange({
              [POIdNbr]: ({ value }) => value
            })}
            {...options}
          />
        );
      case "DATE":
        return (
          <DateInput
            popupPosition="bottom right"
            dateFormat={format}
            value={value}
            iconPosition="left"
            preserveViewMode={true}
            autoComplete="off"
            disabled={isDisabled}
            onChange={this.handleInputChange({
              [POIdNbr]: ({ value }) => value
            })}
            {...options}
          />
        );
      case "TEXT":
        return (
          <div className="ui input">
            <input
              value={value}
              onChange={this.handleInputChange({
                [POIdNbr]: ({ value }) => value
              })}
              {...options}
            />
          </div>
        );
      case "DECIMAL":
        return (
          <Input
            value={value}
            disabled={isDisabled}
            onChange={this.handleInputChange({
              [POIdNbr]: ({ value }) => value
            })}
            onKeyDown={(e) => {
              if (!_.includes([8, 17, 37, 39], e.keyCode) && /^[^\d.]+$/.test(e.key) && !e.ctrlKey) {
                e.preventDefault();
              }
            }}
            {...options}
          />
        );
      default:
        return null;
    }
  };

  handleOpen = () => this.setState({ modalOpen: true });

  handleClose = () => {
    this.props.onPOIdentifierChange(this.state.orderIdentifiers);
    this.setState({ modalOpen: false });
  };

  handleInputChange = data => (event = {}, value) => {
    const { target = {} } = event;
    const targetValue = {
      value: target.value,
      checked: !!target.value
    };

    this.setState(
      {
        orderIdentifiers: {
          ...this.state.orderIdentifiers,
          ...Object.entries(data).reduce(
            (acc, [id, getValue]) => ({
              ...acc,
              [id]:
                typeof getValue === "function"
                  ? getValue(value || targetValue)
                  : getValue || value || targetValue
            }),
            {}
          )
        }
      },
      () => {
        this.props.onPOIdentifierChange(this.state.orderIdentifiers);

        Object.entries(data).map(([id, getValue]) => {
          const onChangeAdditionalFn = onChangeAdditional[id];

          if (typeof onChangeAdditionalFn !== "function") {
            return;
          }

          onChangeAdditionalFn.call(this, id, () => {
            this.props.onPOIdentifierChange(this.state.orderIdentifiers);
          });
        });
      }
    );
  };

  render() {
    const { poidentifiers, orderIdentifiers } = this.state;

    return (
      <Modal
        size="tiny"
        className={`pomodal ${style}`}
        trigger={<Button onClick={this.handleOpen}>PO Identifiers</Button>}
        open={this.state.modalOpen}
        onClose={this.handleClose}
      >
        <Modal.Header>Purchase Order Identifiers</Modal.Header>
        <Modal.Content>
          <Grid centered>
            <Grid.Column>
              <Table celled size="large">
                <Table.Body>
                  {poidentifiers.map(poidentifier => {
                    const { POIdNbr, IdentifierDesc } = poidentifier;

                    if (POIdNbr === "15" && !orderIdentifiers[POIdNbr]) {
                      return;
                    }

                    return (
                      <Table.Row key={POIdNbr} textAlign="left">
                        <Table.Cell>{IdentifierDesc}</Table.Cell>
                        <Table.Cell textAlign="center">
                          {this.getComponentByPOIdentifier(poidentifier)}
                        </Table.Cell>
                      </Table.Row>
                    );
                  })}
                </Table.Body>
              </Table>
            </Grid.Column>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.handleClose}>Apply</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./components/product-detail/POIdentifierModal.js